

import * as React from 'react';

type IconCartSuccesProps = React.SVGProps<SVGSVGElement>;

export const IconCartSucces: React.FC<IconCartSuccesProps> = (props) => (
	<svg width={40} height={44} viewBox="0 0 40 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="11.9443" y="2" width="9.96737" height="17.7198" rx="4.98368" stroke="#FFA692" stroke-width="2.21497"/>
		<path d="M2.93717 12.917C3.01996 11.7579 3.98445 10.8599 5.14651 10.8599H28.7088C29.8709 10.8599 30.8354 11.7579 30.9182 12.917L32.8167 39.4967C32.9083 40.7789 31.8928 41.8695 30.6074 41.8695H3.24797C1.96253 41.8695 0.947041 40.7789 1.03862 39.4967L2.93717 12.917Z" fill="#EFF4F1"/>
		<ellipse cx="27.4756" cy="32.3443" rx="11.6553" ry="11.6556" fill="#8BA293"/>
		<path d="M22.4805 33.0829L25.6592 35.673L32.4707 29.0127" stroke="#EFF4F1" stroke-width="3.33013" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>

);


